import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { StockStoreWorkOrderAllocationService } from "@services/stockStoreWorkOrderAllocation.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "stockStoreWorkOrderAllocations",
	styleUrls: ["stockStoreWorkOrderAllocations.css"],
	templateUrl: "stockStoreWorkOrderAllocations.html"
})
export class StockStoreWorkOrderAllocationsAdminComponent {
	canExportGrid = false;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	isQualityManagement = false;
	itemType = "Stock Store Work order Allocation"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	statuses: any;
	title: string;

	constructor(private appSettingsService: AppSettingsService, private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: StockStoreWorkOrderAllocationService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-eye", method: "viewStockStores", text: "Stock Stores" });
		this.title = `${this.itemType}s`;
		this.getItems();
		this.checkGridExportPermissions();

		this.isQualityManagement = CheckGroupPermissions(appSettingsService, "Quality Management");

		this.isUnQuarantineVisible = this.isUnQuarantineVisible.bind(this);
		this.unQuarantineRow = this.unQuarantineRow.bind(this);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Stock Store Work Order Allocations")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getItems() {
		this.itemService.getGrid()
			.subscribe(
				(res: any) => this.items = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isUnQuarantineVisible(e: any) {
		return this.isQualityManagement === true && e.row.data.isQuarantined === true;
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Stock Store Work Order Allocations";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	unQuarantineRow(e: any) {
		if (this.isQualityManagement === false || e.row.data.isQuarantined === false) {
			return false;
		}

		if (confirm("Remove this item from quarantine?") === false) {
			return false;
		}
		
		this.itemService.unquarantine(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Removed item from Quarantine");
					e.row.data.isQuarantined = false;
					return false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
		return false;
	}

	viewStockStores() {
		this.router.navigate(["admin/stores"]);
	}
}